import React, { Component } from 'react';
// import logo from './logo.svg';
import './App.css';

import { Route, Link } from 'react-router-dom';
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      artists: []
    };
    this.handleClick = this.handleClick.bind(this);
  }
 
  handleClick() {
  }
  render() {
    return (
      <div>
        <nav className="menu navbar navbar-expand-lg bg-dark text-white">
          <Link className="nav-link h4 link" to="/">Portfólio</Link>
          <Link className="nav-link h4 link" to="/projetos">Projetos</Link>
          <Link className="nav-link h4 link" to="/sobre">Sobre</Link>
          <Link className="nav-link h4 link" to="/contato">Contato</Link>
        </nav>

        <Route path="/" exact component={ Home } />
        <Route path="/sobre/" component={ About } />
        <Route path="/projetos" component={ Projects } />
        <Route path="/contato" component={ Contact } />
      </div>
    );
  }
}

const Home = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-sm text-center">
          <img className="img-home align-self-center" alt="arte composta por pessoa trabalhando de frente ao computador" src={require('./imgs/frame-home.png')}></img>
        </div>
        <div className="col-sm align-self-center text-center">
          <h1>Carol Fortunato</h1>
          <h4>Portfólio</h4>
          <p>Programadora Front-End formada na Laboratória.</p>
          <p>Interessada em UX design e Machine Learning.</p>
          <p>Curiosa e apaixonada por um bocado de coisas.</p>
          <p>Nerd acima de tudo. </p>
        </div>
      </div>
    </div>
)}

const About = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md text-center">
          <img className="img-home align-self-center" alt="foto de mulher careca em frente de um fundo com plantas" src={require('./imgs/frame-about.png')}></img>
        </div>
        <div className="col-md align-self-center text-left">
          <h1>Carol Fortunato</h1>
          <h4>Front-End developer</h4>
          <p>Formada em programação Front-End pela Laboratória.</p>
          <p>Com conhecimento de HLML, CSS, UX/UI design, JavaScript funcional, testes únitários e React.</p>
          <p>Interessada em UX design e Machine Learning.</p>
          <p>Formada em Jornalismo na Universidade Cruzeiro do Sul e com experiência em Marketing Digital.</p>
          <p>Curiosa e apaixonada por um bocado de coisas.</p>
          <p>Nerd acima de tudo. </p>
        </div>
      </div>
    </div>
)}

const Projects = () => {
  return (
    <div className="project-page">
      <h1 className="page-title align-self-center text-center">Principais projetos</h1>
      <div class="row">
      <div class="col-md-4">
        <div className="card text-center">
          <img className="card-img-top screenshots" alt="generic" src={require('./imgs/card-recipe-finder.jpg')}></img>
          <div className="card-body">
            <h5 className="card-title">Recipe Finder - SPA</h5>
            <p className="card-text">Esse projeto é um single page app para encontrar receitas que usa a API Yummly para buscar receitas, a biblioteca Routes para criar as páginas e o Firebase como host.</p>
            <p className="card-text"><b>Tags:</b> yummly-api; single-page-app; routes; firebase-hosting; javascript; html; css</p>
            <Link to="//laboratoria-spa-sprint5.firebaseapp.com/" className="btn btn-primary">Visite o projeto</Link>
          </div>
        </div>
      </div>
      
      <div class="col-md-4">
        <div className="card text-center">
          <img className="card-img-top screenshots" alt="generic" src={require('./imgs/card-labgif.jpg')}></img>
          <div className="card-body">
            <h5 className="card-title">Lab Gif</h5>
            <p className="card-text">Esse é um projeto mobile com o objetivo de criar um "Tinder para Gifs" que utiliza a API do Giphy, o Hammer.js e o Firebase. O projeto foi premiado em sua categoria no hackaton da Laboratoria.</p>
            <p className="card-text"><b>Tags:</b> html; css; mobile-first; api; giphy-api; hammerjs; javascript; firebase;</p>
            <Link to="//labgifs.firebaseapp.com/" className="btn btn-primary">Visite o projeto</Link>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div className="card text-center">
          <img className="card-img-top screenshots" alt="generic" src={require('./imgs/card-lib.jpg')}></img>
          <div className="card-body">
            <h5 className="card-title">Validador de Cartão de Crédito</h5>
            <p className="card-text">Essa biblioteca é utilizada para validação de números de cartão. Na versão atual, valida se a sequência de números passadas é um número válido de cartão.</p>
            <p className="card-text"><b>Tags:</b> javascript; javascript-library; node.js; unit-testing; test-driven-development;</p>
            <Link to="//www.npmjs.com/package/xuxu-cardvalidator" className="btn btn-primary">Visite o projeto</Link>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div className="card text-center">
          <img className="card-img-top screenshots" alt="generic" src={require('./imgs/card-labcar.jpg')}></img>
          <div className="card-body">
            <h5 className="card-title">LabCar</h5>
            <p className="card-text">Esse é um desafio de design web responsivo e mobile que inclui modais e mapa.</p>
            <p className="card-text"><b>Tags:</b> html; css; bootstrap; responsive;</p>
            <Link to="//carolfortunato.github.io/labcar/" className="btn btn-primary">Visite o projeto</Link>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div className="card text-center">
          <img className="card-img-top screenshots" alt="generic" src={require('./imgs/card-twitter.jpg')}></img>
          <div className="card-body">
            <h5 className="card-title">Twitter</h5>
            <p className="card-text">Esse é um desafio de desenvolvimento responsivo onde é possível postar conteúdo entre 1 e 140 caracteres.</p>
            <p className="card-text"><b>Tags:</b> html; css; responsive; javascript; bootstrap;</p>
            <Link to="//carolfortunato.github.io/twitter/" className="btn btn-primary">Visite o projeto</Link>
          </div>
        </div>
      </div>
      </div>
  </div>
)}

const Contact = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-sm align-self-center text-center">
          <h1>Fale comigo!</h1>
          <p>Seja meu contato no <Link className="contact-link" to="//www.linkedin.com/in/carolinafortunato">LinkedIn</Link></p>
          <p>Saiba mais sobre meus projetos no <Link className="contact-link" to="//github.com/carolfortunato ">GitHub</Link></p>
          <p>Me siga no <Link className="contact-link" to="//www.instagram.com/cahfortunatoo/">Instagram</Link></p>
          <p>Ou mande um e-mail para <b>carolfortunato@outlook.com</b></p>
        </div>
        <div className="col-sm">
          <img className="img-home align-self-center" alt="imagem composta de diversos aparelhoseletrônicos sendo usados sobre uma mesa" src={require('./imgs/frame-contact.png')}></img>
        </div>
      </div>
    </div>
)}


export default App;